module.exports = __webpack_public_path__ + "img/boton-productos.bd03e710.jpg";